import { useState } from "react";

import { useTranslation } from "@/i18n";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/ui/form-field";

interface Step1Data {
  email: string;
  full_name: string;
}

interface RegisterStep1Props {
  initialData: Step1Data;
  onNext: (data: Step1Data) => void;
}

export function RegisterStep1({
  initialData,
  onNext,
}: RegisterStep1Props) {
  const [email, setEmail] = useState(initialData.email);
  const [fullName, setFullName] = useState(initialData.full_name);
  const { t } = useTranslation();

  return (
    <div>
      <h2 className="text-xl font-medium text-ocean-800">
        {t("auth.register.step1.title")}
      </h2>
      <p className="mt-1 text-sm text-neutral-600">
        {t("auth.register.step1.subtitle")}
      </p>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          onNext({ email, full_name: fullName });
        }}
        className="mt-6 space-y-4"
      >
        <FormField
          label={t("auth.register.step1.fullNameLabel")}
          value={fullName}
          onChange={setFullName}
          placeholder={t("auth.register.step1.fullNamePlaceholder")}
          autoComplete="name"
          required
        />
        <FormField
          label={t("auth.register.step1.emailLabel")}
          type="email"
          value={email}
          onChange={setEmail}
          placeholder={t("auth.register.step1.emailPlaceholder")}
          autoComplete="email"
          required
        />
        <Button type="submit" className="w-full">
          {t("auth.register.step1.nextButton")}
        </Button>
      </form>
    </div>
  );
}
